import styled from 'styled-components';
import colors from 'common/theme/saasModern/colors';
import { saasModernTheme } from 'common/theme/saasModern';

export const SectionImageAndListContainer = styled.div`
  width: 100%;
  minheight: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top:32px;
  margin-bottom:32px;
`;

export const ContainerElement = styled.div`
  display: grid;
  grid-template-columns: 40% 60%;
  gap: 40px;
  margin: 0 auto;
  align-items: center;
  width:100%;
  @media (max-width: 1200px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const LeftSection = styled.div`
  position:relative;
  width:90%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const RightSection = styled.div``;

export const StepList = styled.ol`
  list-style-type: none;
  counter-reset: step-counter;
  padding: 0;
`;

export const StepItem = styled.li`
  counter-increment: step-counter;
  margin-bottom: 20px;
  position: relative;
  padding-left: 40px;
  &::before {
    content: counter(step-counter);
    background-color: #ff6b6b;
    color: white;
    font-weight: bold;
    padding: 3px 8px;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 0;
  }
`;

export const StepTitle = styled.h2`
  margin: 0 0 10px 0;
  font-family: ${saasModernTheme.fontFamily};
  font-size: 16px;
`;

export const StepDescription = styled.div`
  color: ${colors.gray};
  font-family: ${saasModernTheme.fontFamily};
  font-size: 16px;
`;
